import { ESortChainsType } from '@ankr.com/chains-list';
import { memo } from 'react';

import { Search } from 'modules/common/components/Search';
import { ChainsSortSelect } from 'modules/chains/components/ChainsSortSelect';
import { Tab } from 'modules/common/hooks/useTabs';
import { GuardResolution } from 'modules/common/components/GuardResolution';

import { useBaseChainsHeaderStyles } from './useBaseChainsHeaderStyles';
import {
  ChainViewSelector,
  EChainView,
} from '../../screens/ChainsListPage/components/ChainViewSelector';
import { PublicChainsCheckbox } from '../PublicChainsCheckbox';

interface IBaseChainsHeader {
  sortType: ESortChainsType;
  setSortType: (type: ESortChainsType) => void;
  searchContent: string;
  setSearchContent: (searchContent: string) => void;
  chainsViewTabs?: Tab<EChainView>[];
  selectedChainsViewTab?: Tab<EChainView>;
  isPublicChainsChecked: boolean;
  onPublicChainsCheckboxClick: (isSelected: boolean) => void;
}

export const BaseChainsHeader = memo(
  ({
    chainsViewTabs,
    isPublicChainsChecked,
    onPublicChainsCheckboxClick,
    searchContent,
    selectedChainsViewTab,
    setSearchContent,
    setSortType,
    sortType,
  }: IBaseChainsHeader) => {
    const { classes } = useBaseChainsHeaderStyles();

    return (
      <div className={classes.root}>
        <div className={classes.first}>
          <Search
            className={classes.chainsListSearch}
            searchContent={searchContent}
            setSearchContent={setSearchContent}
          />
          <ChainsSortSelect
            className={classes.chainsSortSelect}
            sortType={sortType}
            setSortType={setSortType}
            isDisabled={false}
          />
          <PublicChainsCheckbox
            isChecked={isPublicChainsChecked}
            onClick={onPublicChainsCheckboxClick}
          />
        </div>

        {chainsViewTabs && selectedChainsViewTab && (
          <GuardResolution protectedResolution="smDown">
            <ChainViewSelector
              chainsViewTabs={chainsViewTabs}
              selectedChainsViewTab={selectedChainsViewTab}
            />
          </GuardResolution>
        )}
      </div>
    );
  },
);

BaseChainsHeader.displayName = 'BaseChainsHeader';
